import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ScanResourcesListItem } from "../../../types";

const ScanResourcesTableTypeCell = ({
  item: resource,
  ...cellProps
}: TableSimpleCellProps<ScanResourcesListItem>) => (
  <TableSimpleCell {...cellProps}>
    <TableCellText>{resource.type}</TableCellText>
  </TableSimpleCell>
);

export default ScanResourcesTableTypeCell;
